import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { DateField, TextField } from '@kanos/ui';
import { useState } from 'react';
import { fieldRule, todayIso } from './form.js';
/**
 * The rows of a person's fields where the form is wide enough: the two names side by side, then
 * three to a row - birth date, birthplace, nationality, country of residence.
 */
export const personRowsClassName = 'grid gap-4 @lg:grid-cols-6 @lg:[&>*]:col-span-2 @lg:[&>*:nth-child(-n+2)]:col-span-3';
/**
 * Given name, family name and birth date of a person, as the domain schema checks them - for a
 * beneficial owner and for a remote identification alike: `values` for the request, `set` to
 * fill them in from elsewhere, `fields` for the caller's grid.
 */
export function usePersonFields(initial, 
/** The names' field of the domain schema. */
nameRule, 
/** Whether the form cannot go without the birth date. */
birthDateRequired = false) {
    const [givenName, setGivenName] = useState(initial?.givenName ?? '');
    const [familyName, setFamilyName] = useState(initial?.familyName ?? '');
    const [birthDate, setBirthDate] = useState(initial?.birthDate ?? null);
    const fields = (_jsxs(_Fragment, { children: [_jsx(TextField, { label: "Vorname", placeholder: "z. B. Max", value: givenName, onChange: setGivenName, isRequired: true, validate: fieldRule(nameRule, 'Bitte geben Sie den Vornamen an.') }), _jsx(TextField, { label: "Nachname", placeholder: "z. B. Mustermann", value: familyName, onChange: setFamilyName, isRequired: true, validate: fieldRule(nameRule, 'Bitte geben Sie den Nachnamen an.') }), _jsx(DateField, { label: "Geburtsdatum", value: birthDate, onChange: setBirthDate, maxValue: todayIso(), isRequired: birthDateRequired })] }));
    return {
        values: { givenName, familyName, birthDate },
        set: (person) => {
            setGivenName(person.givenName);
            setFamilyName(person.familyName);
            setBirthDate(person.birthDate);
        },
        fields,
    };
}
//# sourceMappingURL=person-fields.js.map